import { useEffect } from 'react'

const SENTINEL = 'intake-forms-block'

const hasSentinel = (): boolean =>
  Boolean((window.history.state as Record<string, unknown> | null)?.[SENTINEL])

export const useBlockPageExit = (active: boolean): void => {
  useEffect(() => {
    if (!active) return

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = ''
    }

    const handlePopState = () => {
      if (hasSentinel()) return
      window.history.pushState({ [SENTINEL]: true }, '')
    }

    const pushed = !hasSentinel()
    if (pushed) {
      window.history.pushState({ [SENTINEL]: true }, '')
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      window.removeEventListener('popstate', handlePopState)
      if (pushed && hasSentinel()) {
        window.history.back()
      }
    }
  }, [active])
}
